import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { SystemInputsTypes } from "@graylog/server-api";
import { defaultOnError } from "util/conditional/onError";
export const fetchInputTypes = async () => await SystemInputsTypes.types();
const useInputTypes = ({ enabled } = { enabled: true }) => {
  const { data, refetch, isLoading } = useQuery({
    queryKey: ["inputTypes", "types"],
    queryFn: () => defaultOnError(
      fetchInputTypes(),
      "Loading input types failed with status",
      "Could not load input types"
    ),
    placeholderData: keepPreviousData,
    enabled
  });
  return { data: data || { types: {} }, refetch, isLoading };
};
export default useInputTypes;
